import { render, staticRenderFns } from "./GameLoading.vue?vue&type=template&id=79d452aa&scoped=true&"
import script from "./GameLoading.vue?vue&type=script&lang=js&"
export * from "./GameLoading.vue?vue&type=script&lang=js&"
import style0 from "./GameLoading.vue?vue&type=style&index=0&id=79d452aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d452aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d452aa')) {
      api.createRecord('79d452aa', component.options)
    } else {
      api.reload('79d452aa', component.options)
    }
    module.hot.accept("./GameLoading.vue?vue&type=template&id=79d452aa&scoped=true&", function () {
      api.rerender('79d452aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/GameLoading.vue"
export default component.exports